const schemaReduced = {
  id: "",
  name: ""
};

export default schemaReduced;
